import { PaymentMessage } from 'src/devices/payment/dtos/eps-data';
import { PmiStatusCodes } from 'src/devices/payment/pmi-status-codes-enums';
import { EmeraldError } from '../api/emerald-error';
import { EmeraldDialogTypes } from '../enumerations/emerald-dialog-types';
import { IMessageModal } from '../interfaces/dtos/IMessageModal';

export const EPS_PAYMENT_FAILURE = 'EPS_Payment_Failure';

const EPS_Error = 'EPS_Error';
export const PMI_REQUEST_FAILURE = 'PMI_REQUEST_FAILURE';

// The paymentException has same data modal as the PaymentError in RPS
// The error messsage represents the status string in the PMI error in RPS
export class PaymentException extends EmeraldError {
  constructor(error?: any) {
    super();
    // Condition check to format any unexpected errors thrown from payment controller
    if (typeof error !== 'object') {
      this.code = error?.toString() || PMI_REQUEST_FAILURE;
      this.statusCode = PmiStatusCodes.Failed;
      this.message = EPS_Error;
    } else {
      this.code = error.code || PMI_REQUEST_FAILURE;
      this.statusCode = error.statusCode || PmiStatusCodes.Failed;
      this.message = error.message || EPS_Error;
      this.paymentMessage = error.paymentMessage;
    }
  }
  public code: string;
  public statusCode: PmiStatusCodes;
  public paymentMessage?: PaymentMessage;
}

export const parseMessageModalFromPaymentException = (
  exception: PaymentException,
): IMessageModal => {
  const { message, statusCode } = exception;

  switch (statusCode) {
    case PmiStatusCodes.ManualEntryNotAllowed:
      return {
        type: EmeraldDialogTypes.Info,
        message: 'EPS_Manual_Card_Entry_Unauthorized',
        subMessage: 'EPS_Manual_Card_Entry_SubMessage',
        acceptButtonLabel: 'Ok',
        hideCancelButton: true,
      };
    case PmiStatusCodes.Declined:
      return {
        type: EmeraldDialogTypes.Info,
        message: 'EPS_Declined_Caption',
        subMessage: 'EPS_Declined_Sub_Message',
        acceptButtonLabel: 'Ok',
        hideCancelButton: true,
      };
    case PmiStatusCodes.Failed:
      return {
        type: EmeraldDialogTypes.Info,
        message: EPS_PAYMENT_FAILURE,
        subMessage: '',
        acceptButtonLabel: 'Ok',
        hideCancelButton: true,
      };
    case PmiStatusCodes.Cancelled:
      return {
        type: EmeraldDialogTypes.Info,
        message: 'EPS_Declined_Caption',
        subMessage: 'EPS_PaymentCancelledByCustomerMessage',
        hideCancelButton: true,
      };
    default:
      return {
        type: EmeraldDialogTypes.Info,
        message,
        acceptButtonLabel: 'Ok',
        hideCancelButton: true,
      };
  }
};
